import { useState } from 'react';
import { Box, CircularProgress, Grid, Typography } from '@material-ui/core';
import { initialAddressState } from 'config/constants';
import { StepApi } from 'services';
import { useAddressesFunctions } from 'contexts/AddressContext';
import { useCompany } from 'contexts/CompanyContext';
import { useHistory } from 'react-router-dom';
import AddressForm from 'components/AddressForm';
import DefaultButton from 'components/DefaultButton';
import MaiaLogo from 'components/MaiaLogo';
import RegisterLayout from 'pages/RegisterLayout';
import routes from 'config/routes';
import sideImage from '_assets/register/Place.svg';
import useStyles from './styles';

const RegisterAddress = () => {
  const classes = useStyles();
  const history = useHistory();

  const { currentCompany } = useCompany();
  const { createAddress } = useAddressesFunctions();

  const [sameAddress, setSameAddress] = useState(null);

  const updateRegisterStep = async () => {
    try {
      await StepApi.updateStep(currentCompany.id, 'place_created');
    } catch (e) {}
  };

  const onSamePlaceClick = () => {
    setSameAddress(true);
    updateRegisterStep().then(() => {
      history.push(routes.home.root);
    });
  };

  const handleCancelForm = () => {
    history.push(routes.home.root);
  };

  const handleSubmitForm = async (values) => {
    const body = {
      address: values.address_name,
      city: values.city_name,
      title: values.title,
      index: values.street_index,
      number: values.street_number,
      zipCode: values.zip_code,
    };

    const { created } = await createAddress(body);
    if (created) {
      await updateRegisterStep();
      history.push(routes.home.root);
    }

    return { success: created };
  };

  const SideComponent = () => (
    <Grid container direction='column' style={{ height: 'auto' }}>
      <Grid container item justifyContent='center'>
        <MaiaLogo />
      </Grid>

      <Grid container item justifyContent='center' style={{ marginTop: '8vh' }}>
        <img src={sideImage} alt='Place' width={120} />
      </Grid>

      <Grid container item justifyContent='center' style={{ marginTop: '3vh' }}>
        <Typography className={classes.text} align='center' variant='h3'>
          Dites nous où se déroulent vos activités.
        </Typography>
        <Typography className={classes.text} align='center' variant='h3' style={{ marginTop: '3vh' }}>
          Dans certains cas les activités se déroulent ailleurs qu’au siège social
        </Typography>
        <Typography className={classes.text} align='center' variant='h3' style={{ marginTop: '3vh' }}>
          L’adresse peut même varier en fonction des activités !
        </Typography>
      </Grid>
    </Grid>
  );

  return (
    <RegisterLayout SideComponent={<SideComponent />}>
      <Grid container direction='column' style={{ height: 'auto' }}>
        <Grid className={classes.header} container item justifyContent='center'>
          <Grid className={classes.title} container item xs={12} md={9} justifyContent='center'>
            <Typography variant='h1'>Votre lieux de prestation</Typography>
          </Grid>

          <Grid className={classes.title} container item xs={12} md={9} justifyContent='center'>
            <Typography align='center' variant='h2'>
              Définissons l'adresse où la prestation aura lieu
            </Typography>
          </Grid>
        </Grid>

        <Grid container item justifyContent='center'>
          <Grid container item xs={12} md={9} alignItems='center' justifyContent='space-between'>
            <Typography className={classes.subtitle}>
              Mon lieu d’activité est le même que mon siège social ?
            </Typography>

            <Box className={classes.headerButtonContainer}>
              <DefaultButton
                className={classes.headerButton}
                color={sameAddress === null ? 'default' : !sameAddress ? 'primary' : 'default'}
                variant={sameAddress === null ? 'outlined' : !sameAddress ? 'contained' : 'outlined'}
                standard={sameAddress !== null && !sameAddress}
                onClick={() => setSameAddress(false)}
              >
                Non
              </DefaultButton>

              <DefaultButton
                className={classes.headerButton}
                color={sameAddress === null ? 'default' : sameAddress ? 'primary' : 'default'}
                disabled={sameAddress}
                variant={sameAddress === null ? 'outlined' : sameAddress ? 'contained' : 'outlined'}
                standard={sameAddress !== null && sameAddress}
                onClick={onSamePlaceClick}
              >
                {sameAddress ? <CircularProgress size={20} /> : 'Oui'}
              </DefaultButton>
            </Box>
          </Grid>
        </Grid>

        <Grid container item justifyContent='center'>
          <Grid container item xs={12} md={9}>
            <Typography className={classes.formSubtitle}>
              Vous pourrez créer plusieurs lieux en allant dans vos paramètres
            </Typography>
          </Grid>
        </Grid>

        <Grid container item justifyContent='center' style={{ flexGrow: 1 }}>
          <AddressForm
            address={initialAddressState}
            disabled={sameAddress !== false}
            onCancel={handleCancelForm}
            onSubmit={handleSubmitForm}
          />
        </Grid>
      </Grid>
    </RegisterLayout>
  );
};

export default RegisterAddress;
